import { useMemo } from 'react';
import { DivisionGroup, useLocationGroups } from './useLocationGroups';

export const useDivisionForLocation = (locationId: number): DivisionGroup => {
  const groups = useLocationGroups();

  return useMemo(() => {
    const division = groups.find(group => group.locations.some(location => location.id === locationId));
    if (!division) {
      throw new Error(`Division for location ID ${locationId} not found`);
    }
    return division;
  }, [groups, locationId]);
};
